import { render, staticRenderFns } from "./BuildingAndRoomModal.vue?vue&type=template&id=44f2fc16&scoped=true&"
import script from "./BuildingAndRoomModal.vue?vue&type=script&lang=js&"
export * from "./BuildingAndRoomModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f2fc16",
  null
  
)

export default component.exports